/**
 * File: remove-posted.js
 *
 * Remove 'Posted' from wp job manager posted date - the_job_publish_date.
 */

// Make sure everything is loaded first.
if (
  ("complete" === document.readyState || "loading" !== document.readyState) &&
  !document.documentElement.doScroll
) {
  remove_posted();
} else {
  document.addEventListener("DOMContentLoaded", remove_posted);
}

/**
 * Handle our mobile menus.
 *
 * @author Julian M.
 */
function remove_posted() {
  const postedDate = document.querySelector(
    ".single-job_listing .posted-date time",
  );

  if (!postedDate) return;

  const newText = postedDate.innerText.replace("Posted ", "");
  postedDate.innerText = newText;
}
